import styled from "styled-components";
import "moment/locale/nl";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useProperty } from "../hooks/properties/useProperty";
import NAV from "../utils/nav.const";
import PropertyDetails from "./PropertyDetails";
import Complex from "./Complex";
import { useAgentGroups } from "../context/AgentGropusContext";

const Property = () => {
  const { slug } = useParams();
  const [propertyFound, setPropertyFound] = useState(true);
  const [propertyType, setPropertyType] = useState("");
  const { agentGroups } = useAgentGroups();
  const [currentAgentGroup, setCurrentAgentGroup] = useState<any>();
  const navigate = useNavigate();
  const {
    getPropertyBySlug,
    data: property,
    loading: loadingProperty,
  } = useProperty();

  useEffect(() => {
    if (property?.type?.name) {
      setPropertyType(property.type.name);
    }
  }, [property]);

  useEffect(() => {
    if (!loadingProperty && !property) {
      setPropertyFound(false);
    }
    if (!loadingProperty && property) {
    }
  }, [loadingProperty, property]);

  useEffect(() => {
    getPropertyBySlug(slug);
  }, [slug]);

  const scrollTop = () => {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  };

  useEffect(() => {
    scrollTop();
  }, []);
  useEffect(() => {
    if (property && agentGroups) {
      setCurrentAgentGroup(() =>
        agentGroups.find(
          (agentGroup: any) => agentGroup.id === property.agentGroupId
        )
      );
    }
  }, [agentGroups, property]);
  useEffect(() => {
    if (property) {
      document.title = `${property?.title} - GoHome.rent`;
    }
  }, [property]);

  useEffect(() => {
    if (!propertyFound) {
      navigate("/" + NAV.NO_MATCH);
    }
  }, [propertyFound, navigate]);

  return (
    <>
      {!propertyFound && <ErrorContainer />}
      {propertyType === "Collection" && (
        <Complex
          currentAgentGroup={currentAgentGroup}
          property={property}
          loadingProperty={loadingProperty}
        />
      )}
      {propertyType === "Property" && (
        <PropertyDetails
          currentAgentGroup={currentAgentGroup}
          property={property}
          loadingProperty={loadingProperty}
        />
      )}
    </>
  );
};

export default Property;

export const ErrorContainer = styled("div")({
  backgroundColor: "#fff",
});
